import React from 'react';

function Icon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="3.5"
        fill="#F3F5F7"
        stroke="#E1E6EB"
      />
      <path
        d="M10.7881 6.43271C10.8259 6.01771 11.1738 5.69995 11.5905 5.69995H12.4099C12.8266 5.69995 13.1745 6.01771 13.2123 6.43271C13.2432 6.77342 13.4884 7.05157 13.8088 7.17163C13.8911 7.20249 13.9725 7.23541 14.0529 7.27031C14.3698 7.40806 14.7426 7.38166 15.0081 7.1604C15.3362 6.887 15.8187 6.90888 16.1206 7.21087L16.699 7.78918C16.9869 8.0771 17.0078 8.53708 16.7471 8.8499C16.53 9.11045 16.5097 9.47834 16.6557 9.7845C16.7189 9.91708 16.7766 10.0528 16.8285 10.1913C16.9486 10.5117 17.2267 10.7569 17.5674 10.7879C17.9824 10.8256 18.3002 11.1736 18.3002 11.5903V12.4096C18.3002 12.8263 17.9824 13.1743 17.5674 13.212C17.2267 13.243 16.9486 13.4882 16.8285 13.8086C16.7819 13.9329 16.7306 14.055 16.6749 14.1746C16.5395 14.4651 16.5615 14.8121 16.7666 15.0583C17.0163 15.3579 16.9963 15.7983 16.7206 16.074L16.0742 16.7204C15.7985 16.996 15.3581 17.016 15.0586 16.7664C14.8123 16.5612 14.4654 16.5393 14.1748 16.6747C14.0553 16.7304 13.9332 16.7817 13.8088 16.8283C13.4884 16.9483 13.2432 17.2265 13.2123 17.5672C13.1745 17.9822 12.8266 18.3 12.4099 18.3H11.5905C11.1738 18.3 10.8259 17.9822 10.7881 17.5672C10.7571 17.2265 10.5119 16.9483 10.1916 16.8283C10.053 16.7764 9.91733 16.7187 9.78476 16.6555C9.4786 16.5095 9.1107 16.5297 8.85014 16.7468C8.53732 17.0075 8.07734 16.9867 7.78941 16.6987L7.21112 16.1204C6.90912 15.8184 6.88724 15.336 7.16065 15.0079C7.38191 14.7424 7.40831 14.3696 7.27055 14.0526C7.23566 13.9723 7.20275 13.891 7.17188 13.8086C7.05182 13.4882 6.77366 13.243 6.43295 13.212C6.01795 13.1743 5.7002 12.8263 5.7002 12.4096V11.5903C5.7002 11.1736 6.01795 10.8256 6.43295 10.7879C6.77367 10.7569 7.05182 10.5117 7.17188 10.1913C7.20816 10.0945 7.24727 9.99908 7.28911 9.90513C7.43717 9.57266 7.41256 9.17917 7.17957 8.89958C6.89544 8.55863 6.91819 8.05728 7.23201 7.74345L7.74369 7.23177C8.05752 6.91794 8.55886 6.8952 8.89981 7.17933C9.17941 7.41232 9.5729 7.43692 9.90537 7.28887C9.99932 7.24703 10.0948 7.20792 10.1916 7.17164C10.5119 7.05158 10.7571 6.77343 10.7881 6.43271Z"
        stroke="var(--text-color-3)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8894 11.9999C13.8894 13.0437 13.0432 13.8899 11.9994 13.8899C10.9555 13.8899 10.1094 13.0437 10.1094 11.9999C10.1094 10.956 10.9555 10.1099 11.9994 10.1099C13.0432 10.1099 13.8894 10.956 13.8894 11.9999Z"
        stroke="var(--text-color-3)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Icon;
